import { Controller } from 'stimulus';
import Sortable from 'sortablejs';

export default class extends Controller {

  static targets = ['dragContainer']

  connect() {
    this.sortables = this.dragContainerTargets.map((container) => {
      return Sortable.create(container, {
        group: 'shared-blocks',
        animation: 200,
        handle: ':not(.no-drag)',
        ghostClass: 'sortable-ghost',
        onEnd: (event) => {
          const el = event.item;
          const target = event.to;
          const source = event.from;
          const sibling = el.nextElementSibling;
 
          this.changePosition(el, target, source, sibling);
        }
      });
    });
  }
  
  changePosition(el, target, source, sibling) {
    var stepList = document.querySelector(".steps");
    var projectId = stepList.getAttribute("data-project-id");
    var taskListId = stepList.getAttribute("data-task-list-id");
    var taskId = this.dragContainerTarget.getAttribute("data-task-id");
    var elementId = el.getAttribute("data-block-id");
    var siblingId = null;

    // There might be a hidden input element near the dropped task block
    // so we will get the immediate next element of input element
    if(sibling.tagName === "INPUT") {
      sibling = sibling.nextElementSibling
    }
    
    if(sibling !== null) {
      siblingId = sibling.getAttribute("data-block-id")
    }
    
    let data = { id: elementId, sibling_id: siblingId };
    
    fetch(`/${accountId}/projects/${projectId}/task_lists/${taskListId}/tasks/${taskId}/task_blocks/${elementId}/update_position`,{
      method: "PATCH",
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((response) => {
      if (!response.ok) {
        throw response
      }
      return response.json();
    }).then((responseJson) => {
      if(responseJson.sibling_present === true) {
        sibling = el.previousElementSibling
      }

      let elStepSettings = el.querySelector(".block-settings");
      let siblingStepSettings = sibling.querySelector(".block-settings");
      
      elStepSettings.outerHTML = responseJson.current_block_setting;
      siblingStepSettings.outerHTML = responseJson.sibling_block_setting;
    }).catch((error) => {
      console.log(error)
    })
  }

}
